// ---------------------------------------------------------------------------
// Financeiro · Contas bancárias — helpers de EXIBIÇÃO (handoff 0079).
//
// A máscara de CPF/CNPJ é compartilhada (`src/utils/format.js`); aqui ficam só
// os formatos próprios do domínio bancário.
// ---------------------------------------------------------------------------

import { ACCOUNT_TYPE_LABELS, PIX_KEY_TYPE_LABELS } from '../constants';

const DASH = '—';

export function orDash(value) {
   const text = String(value ?? '').trim();
   return text || DASH;
}

// "1234-X" (agência) ou "56789-0" (conta). Sem dígito, devolve só o número.
export function formatBankNumber(number, digit) {
   const base = String(number ?? '').trim();
   if (!base) return DASH;
   const dv = String(digit ?? '').trim();
   return dv ? `${base}-${dv}` : base;
}

// Linha condensada da conta para a tabela: "Banco do Brasil · Ag. 1234-X · C/C 56789-0".
// Cada pedaço só entra se existir — conta sem dados bancários é válida (o que o
// sistema exige de fato é a credencial).
export function formatBankLine(account) {
   if (!account) return DASH;

   const parts = [];

   const bank = String(account.bank_name ?? '').trim();
   const code = String(account.bank_code ?? '').trim();
   if (bank && code) parts.push(`${bank} (${code})`);
   else if (bank) parts.push(bank);
   else if (code) parts.push(`Banco ${code}`);

   const agency = formatBankNumber(account.agency, account.agency_digit);
   if (agency !== DASH) parts.push(`Ag. ${agency}`);

   const number = formatBankNumber(account.account_number, account.account_digit);
   if (number !== DASH) {
      const typeLabel = ACCOUNT_TYPE_LABELS[account.account_type];
      parts.push(typeLabel ? `${typeLabel} ${number}` : `Conta ${number}`);
   }

   return parts.length ? parts.join(' · ') : DASH;
}

// "11.222.333/0001-81 (CNPJ)" — o tipo só aparece quando o backend o informa.
export function formatPixKey(account) {
   const key = String(account?.pix_key ?? '').trim();
   if (!key) return DASH;
   const typeLabel = PIX_KEY_TYPE_LABELS[account?.pix_key_type];
   return typeLabel ? `${key} (${typeLabel})` : key;
}

export function formatDateBr(value) {
   if (!value) return DASH;
   const date = new Date(value);
   if (Number.isNaN(date.getTime())) return DASH;
   return date.toLocaleDateString('pt-BR');
}

// Data + hora — usado no histórico de credenciais e no carimbo do teste de
// conexão, onde o minuto importa para o operador saber se o dado é recente.
export function formatDateTimeBr(value) {
   if (!value) return DASH;
   const date = new Date(value);
   if (Number.isNaN(date.getTime())) return DASH;
   return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
   });
}
